// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bind-wecom__tip[data-v-0e01d282] {\n  margin-bottom: 0.75rem;\n  color: #606266;\n  font-size: 1.125rem;\n  line-height: 1.375rem;\n  text-align: center;\n}\n.bind-wecom__panel[data-v-0e01d282] {\n  display: flex;\n  justify-content: center;\n  min-height: 26rem;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
